import React from "react";
import { UiCustomPopup } from "../../../_uiComponents/common/UiModal";
import { DfccCardIcon } from "../../../../styles/img/svg/Bills/DfccCardIcon";
import { SomethingWrongModal } from "../../../_uiComponents/Popups/SomethingWrongModal";
import { ConfirmationIcon } from "../../../../styles/img/svg/ConfirmationIcon";
import { useTranslation } from "react-i18next";
import { UiGrayBgLoader } from "../../../_uiComponents/common/UiGrayBgLoader";

export const SelectPayeeTypesPopup = (props) => {
  const { t, i18n } = useTranslation();

  const {
    payeeTypeList,
    isPayeeTypeListLoading,
    goToDfccCreditCardBillForm,
    openModal,
    closeModal,
    isNoPaddingImage
  } = props;

  return (
    <>
      <UiCustomPopup
        openModal={openModal}
        handleClose={closeModal}
        showCloseIcon
        className="df-view-acc-actions-pp"
      >
        {isPayeeTypeListLoading ? (
          <UiGrayBgLoader className="df-ch-330" />
        ) : Array.isArray(payeeTypeList) && payeeTypeList?.length > 0 ? (
          <div className="df-vertical-icon-card">
            {payeeTypeList?.map((paymentType) => {
              return (
                <div className="df-vertical-icon-card__item">
                  <div
                    onClick={() => {
                      goToDfccCreditCardBillForm({
                        flowType: paymentType?.routingType,
                        flowName: paymentType?.name,
                        payeeTypeId: paymentType?.payeeTypeId,
                        imgUrl: paymentType?.serviceProviderLogo,
                      });
                    }}
                    className="df-vertical-icon-card__item-content"
                  >
                    <img
                      src={paymentType?.serviceProviderLogo}
                      alt=""
                      className={`${isNoPaddingImage ? 'df-rounded-border-logo-sm' : ' df-rounded-border-logo' } df-rounded-logo`}
                    />
                    <p>{paymentType?.name}</p>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <SomethingWrongModal
            icon={<ConfirmationIcon />}
            message={t("Feature Unavailable")}
            buttonText={t("Ok")}
            buttonOnClick={closeModal}
            className="df-confirmation-message-popup df-btn-grpdmodal"
            buttonClass="df-ui-dark-bg-btn df-w-90-btn"
          >
            <p>
              {t(
                "This feature is currently unavailable. Please check back later.",
              )}
            </p>
            <br />
          </SomethingWrongModal>
        )}
      </UiCustomPopup>
    </>
  );
};
